/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function(){
try{
  var url = location.href;
  if(url.includes('/blogs/')){
    jQuery('main a').each(function(index){
      var _this = this;
      var href = jQuery(_this).attr('href') || '';
      console.log('>>>>', href);
      if(!href){ return; }
      if(href.includes('://')===false){ return; }
      if(href.includes('samplingdepot.com')===false){
          jQuery(_this).attr('target', '_blank');
      }
    });
  }
}catch(error){}
});

jQuery(document).ready(function(){
  var sd_collec_req_terms_classes = '.sd-cat-verifit-irritant-smoke-generators-kits,.sd-cat-irritant-smoke-tube-kits-tubes';
  if(jQuery(sd_collec_req_terms_classes).length<1){ 
    console.log('<<<<');
    return; 
  }
  function dothis(){
    jQuery(sd_collec_req_terms_classes).each(function(index){
     var _frm = jQuery(this).find('form');
      if(_frm.length<1){ return; }
      if(_frm.find('.sd-agree-terms').length>0){ return; }
  	 jQuery(_frm).append('<button class="button button--primary button--small sd-agree-terms" style="display:block">Add to cart</button>');
    });
  }
  dothis();
  setTimeout(function(){
  	dothis();
  },2000);
  setTimeout(function(){
  	dothis();
  },4000);
});
jQuery(document).on('click','.sd-agree-terms', function(evt){
  //if(window.accepted){ return; }
  evt.preventDefault();
  jQuery('body').addClass('sd-agree-terms-active');
  var _this = this;
  setTimeout(function(){
    var ans = confirm('\nWARNING \n\nBefore using this product, read, understand and comply with all labels, warnings, instructions. \n\nIf you agree to this, then please choose OK to continue adding this product.\n\n\n');
    console.log('ans',ans);
    if(ans===true){
      //jQuery(_this).hide();
      //jQuery('.sd-cat-verifit-irritant-smoke-generators-kits button').show();
      jQuery(_this).closest('form').find('[type="submit"]').trigger('click');
    }
    jQuery('body').removeClass('sd-agree-terms-active');
  },10);
  return; 
});



var sd_search_cat = '';
if(location.href.includes('/gastec-detector-tubes')){ sd_search_cat = 'Gastec Detector Tubes'}
if(location.href.includes('/nextteq-detector-tubes')){ sd_search_cat = 'nextteq-detector-tubes'}
if(sd_search_cat!==''){
jQuery('header.card__header').append(``);
}

jQuery(document).ready(function(){
  var url = location.href;
  if(url.includes('/collections/nextteq-pumps') || url.includes('/collections/gastec-pumps')){
    if(jQuery('h1.collection__title.heading.h1').length>1){
      jQuery('.collection__meta-inner > h1.collection__title.heading.h1').hide();
    }
  }
});
